/* @flow */

import AddSupplierContactPersonRequest from 'models/requests/confirming/AddSupplierContactPersonRequest';

export default class CompanyConfirmingAddSupplierTabContactForm {
  titleId: number;
  firstName: string;
  lastName: string;
  email: string;
  languageId: number;
  functionName: string;

  constructor() {
    this.titleId = 0;
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.languageId = 0;
    this.functionName = '';
  }

  toRequest(companyId: number, supplierCompanyId: number) {
    const request = new AddSupplierContactPersonRequest();
    request.companyId = companyId;
    request.supplierCompanyId = supplierCompanyId;
    request.titleId = this.titleId;
    request.firstName = this.firstName;
    request.lastName = this.lastName;
    request.email = this.email;
    request.languageId = this.languageId;
    request.functionName = this.functionName;
    return request;
  }
}
